exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-60ec37ad]{width:1050px;margin:50px auto;border:1px solid #eee}.link_a[data-v-60ec37ad]{border-bottom:1px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-60ec37ad","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/info_manage/audit_agreement/audit_brand.vue
// module id = 389
// module chunks = 0